/** @file Field check for a non-empty string, optionally matching a pattern. */
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check for a non-empty string (matching `pattern` when given). */
export function checkString(pattern?: RegExp): FieldCheck {
  const expected = pattern === undefined ? 'non-empty string' : `string matching ${String(pattern)}`;
  return (value, path) => {
    if (typeof value !== 'string' || value === '' || (pattern !== undefined && !pattern.test(value))) failField(path, expected, value);
  };
}
